import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=50692d84&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=ts"
export * from "./DistributorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50692d84",
  null
  
)

export default component.exports